import * as React from 'react';
import * as styles from './styles.css';

import { Tabs as TabsUIKit } from '@cian/ui-kit/prev';

import { ETabs } from '../../types/redux/tabs';

export interface ITabs {
  value: ETabs;
  title: string;
}

export interface ITabsProps {
  onChange(tab: ETabs): void;
  activeTab: ETabs;
  tabs: ITabs[];
}

export function Tabs({ tabs, activeTab, onChange }: ITabsProps) {
  return (
    <div className={styles['container']}>
      <TabsUIKit tabs={tabs} activeTab={activeTab} onChange={onChange} />
    </div>
  );
}
